import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrows-exchange-2', 'ArrowsExchange2', [["path",{"d":"M17 10h-14l4 -4"}],["path",{"d":"M7 14h14l-4 4"}]]);